<template>
  <form role='form'>
    <div class='modal-body'>
      <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
        <ul v-if='validationErrors'>
          <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
        </ul>
      </div>
      <div class='alert alert-success alert-dismissable' v-if='CollectorsSuccess'>
        {{CollectorsSuccess}}
      </div>
      <fieldset>
        <div class='form-group col-lg-4 col-sm-4'>
          <label>التاريخ:</label>
          <input disabled  :value="expDate" class='form-control' name='branchname' type='text'>
        </div>
        <div class='form-group col-lg-4 col-sm-4'>
          <label>الفنى:</label>
          <input disabled  :value="CollectorName" class='form-control' name='branchname' type='text'>
        </div>
        <div class='form-group col-lg-4 col-sm-4'>
          <label>الاجمالى:</label>
          <input disabled  :value="total" class='form-control' name='branchname' type='text'>
        </div>
        <div class='form-group col-lg-2 col-sm-2'>
          <label>المبلغ:</label>
          <input v-model="record.amount" class='form-control' name='branchname' type='text'>
        </div>
        <div class='form-group col-lg-10 col-sm-10'>
          <label>المصروف:</label>
          <input v-model="record.expenses" class='form-control' name='branchname' type='text'>
        </div>
      </fieldset>
      <div>
          <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
            <thead>
              <tr>
                <th style='text-align: center'>الكود</th>
                <th style='text-align: center'>المبلغ</th>
                <th style='text-align: center'>المصروف</th>
                <th style='text-align: center'>الاجراء</th>
              </tr>
            </thead>
            <tbody>
              <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>
                <td align='center'>{{index+1}}</td>
                <td align='center'>{{record.amount}}</td>
                <td align='center'>{{record.expenses}}</td>
                <td align='center'>
                    <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <button @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                    <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' >تعديل</button>
                  </td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
    <div class='modal-footer'>
      <button @click='saveData()' type='button' class='btn btn-outline btn-success btn-md '>
      حفظ
      </button>
      <button @click='showForm(0)' type='button' class='btn btn-outline btn-info btn-md '>
      جديد
      </button>
      <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
    </div>
  </form>
</template>
<script>
import axios from 'axios'
export default {
  name: 'DailyExpenses',
  data () {
    return {
      total: 0,
      CollectorName: null,
      CollectorID: null,
      expDate: null,
      validationErrors: '',
      CollectorsSuccess: null,
      records: [],
      record: '',
      errorShow: false,
      isLoadingData: false,
      isLoadingSave: false
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
  },
  methods: {
    loadPage (date, CollectorID, CollectorName) {
      this.records = ''
      this.expDate = date
      this.CollectorID = CollectorID
      this.CollectorName = CollectorName
      this.GetData()
      this.showForm(0)
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-expenses-temp', {
        token: localStorage.getItem('token'),
        date: this.expDate,
        collector_id: this.CollectorID
      })
        .then(({ data }) => {
          this.records = data
          this.total = 0
          var i = 0
          for (i in data) { this.total += data[i].amount }
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ===========================================================
    showForm (recID) {
      if (recID === 0) {
        this.record = {'id': 0, 'expenses': '', 'amount': ''}
      } else {
        this.record = recID
      }
    },
    // ===========================================================
    saveData () {
      this.CollectorsSuccess = ''
      this.validationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'save-expenses-temp', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        date: this.expDate,
        collector_id: this.CollectorID,
        expenses: this.record.expenses,
        amount: this.record.amount
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
          }
          this.CollectorsSuccess = 'تم الحفظ بنجاح'
          this.total = 0
          var i = 0
          for (i in this.records) { this.total += this.records[i].amount }
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingSave = false
        })
    },
    // ===========================================================
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'delete-expenses-temp', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/Daily/DailyExpenses.vue